export default __webpack_public_path__ + "static/media/10_fooddiary__may.83f1047f.jpg";